/**
 * Step indices for CreateAutomationWizard match the MUI Stepper after `steps` is built:
 * - Non-recurring: 0 action, 1 trigger, 2 name
 * - Recurring (no triggers): 0 action, 1 name
 */

export function getMaxReachableStepIndex({
  selectedAction,
  isRecurring,
  selectedTrigger,
}: {
  selectedAction: string | null;
  isRecurring: boolean;
  selectedTrigger: string | null;
}): number {
  if (!selectedAction) {
    return 0;
  }
  if (isRecurring) {
    return 1;
  }
  if (!selectedTrigger) {
    return 1;
  }
  return 2;
}
